import { createI18n } from 'vue-i18n';
import { en } from '@/lang/en';
import { it } from '@/lang/it';
import store from '@/store';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

let lang;
if (params?.language && params?.language.toUpperCase() === 'EN') {
  store.dispatch('setLanguage', 'EN');
  lang = en;
} else {
  store.dispatch('setLanguage', 'IT');
  lang = it;
}

export const i18n = createI18n({
  locale: 'lang',
  fallbackLocale: 'lang',
  messages: { lang },
  lazy: true
});
